module.exports = __webpack_public_path__ + "img/icon-cart.12d20d01.png";